/**
 * The Filters popover's model, shared by every report page.
 *
 * These are sent to the API as query params, NOT applied in the browser:
 * the busiest report pages are server-paginated, so narrowing the fetched
 * page here would only ever search the rows currently on screen.
 */

export const FILTER_CONDITIONS = ['contains', 'equals', 'starts with', 'ends with'] as const;

export type FilterCondition = (typeof FILTER_CONDITIONS)[number];

export interface ReportFilterRow {
  field: string;
  condition: FilterCondition;
  value: string;
}

export function newFilterRow(field: string): ReportFilterRow {
  return { field, condition: 'contains', value: '' };
}

/** Rows the user actually filled in — an empty value is no constraint. */
export function activeFilters(rows: readonly ReportFilterRow[]): ReportFilterRow[] {
  return rows.filter((row) => row.value.trim() !== '');
}

/**
 * Serialise for the `filters` query param. Returns undefined when nothing
 * is set, so the param is omitted rather than sent as an empty array.
 */
export function serialiseFilters(rows: readonly ReportFilterRow[]): string | undefined {
  const active = activeFilters(rows);
  return active.length === 0 ? undefined : JSON.stringify(active);
}
